import { render } from "./RiSort.vue?vue&type=template&id=c4fffc2a"
import script from "./RiSort.vue?vue&type=script&lang=js"
export * from "./RiSort.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4fffc2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4fffc2a', __exports__)) {
    api.reload('c4fffc2a', __exports__)
  }
  
  module.hot.accept("./RiSort.vue?vue&type=template&id=c4fffc2a", () => {
    api.rerender('c4fffc2a', render)
  })

}


export default __exports__